var React = require('react');

function Appp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M105.146 0H0V69H105.146L141 33.12L105.146 0Z","fill":"#42944A","key":0}),React.createElement("path",{"d":"M32.3027 42.8359H21.002L18.8535 49.2812H12L23.6445 18H29.6172L41.3262 49.2812H34.4727L32.3027 42.8359ZM22.7422 37.6152H30.5625L26.6309 25.9062L22.7422 37.6152Z","fill":"white","key":1}),React.createElement("path",{"d":"M60.7109 23.3223V25.7012H47.0664V23.3223H60.7109ZM55.1602 17.5117V32.0039H52.6309V17.5117H55.1602Z","fill":"white","key":2}),React.createElement("path",{"d":"M76.5977 23.3223V25.7012H62.9531V23.3223H76.5977ZM71.0469 17.5117V32.0039H68.5176V17.5117H71.0469Z","fill":"white","key":3}),React.createElement("path",{"d":"M92.4844 23.3223V25.7012H78.8398V23.3223H92.4844ZM86.9336 17.5117V32.0039H84.4043V17.5117H86.9336Z","fill":"white","key":4})]);
}

Appp.defaultProps = {"width":"141","height":"69","viewBox":"0 0 141 69","fill":"none"};

module.exports = Appp;

Appp.default = Appp;
